import { PatientActions } from 'src/redux/actions/constant';

const { GET_SUCCESS_ENTERPRISE_PHYSICIAN, GET_FAILURE_ENTERPRISE_PHYSICIAN ,GET_REQUEST_ENTERPRISE_PHYSICIAN} = PatientActions;

const intialEnterprisePhysicianState: object = {
  enterprisePhysician: null,
  isError: false,
  errorMessage: '',
  loading: false,
};
export const getEnterprisePhysicianReducer = (
  state = intialEnterprisePhysicianState,
  action: any
) => {
  switch (action.type) {
    case GET_SUCCESS_ENTERPRISE_PHYSICIAN: {
      return {
        ...state,
        isError: false,
        enterprisePhysician: action.payload?.data,
        loading: false,
      };
    }

    case GET_FAILURE_ENTERPRISE_PHYSICIAN:
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        enterprisePhysician: null,
        loading: false,
      };
    case GET_REQUEST_ENTERPRISE_PHYSICIAN:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
